import { AllowObservableContextBaseConstruct } from '../../../../../core/observable/context/base/constructor';
import { ObservableContextBase } from '../../../../../core/observable/context/base/implementation';
import { OBSERVABLE_CONTEXT_BASE_PRIVATE } from '../../../../../core/observable/context/base/privates';
import { AsyncDistinctValueObservableEmit } from '../functions';
export function NewAsyncDistinctValueObservableContext(observable) {
    AllowObservableContextBaseConstruct(true);
    const context = new AsyncDistinctValueObservableContext(observable);
    AllowObservableContextBaseConstruct(false);
    return context;
}
export function AsyncDistinctValueObservableGetObservable(instance) {
    return instance[OBSERVABLE_CONTEXT_BASE_PRIVATE].observable;
}
export function AsyncDistinctValueObservableContextEmit(context, factory) {
    return AsyncDistinctValueObservableEmit(context.observable, factory);
}
export class AsyncDistinctValueObservableContext extends ObservableContextBase {
    constructor(observable) {
        super(observable);
    }
    get observable() {
        return AsyncDistinctValueObservableGetObservable(this);
    }
    emit(factory) {
        return AsyncDistinctValueObservableContextEmit(this, factory);
    }
}
//# sourceMappingURL=implementation.js.map